import { render } from "./S148675.vue?vue&type=template&id=1b56d6c6"
const script = {}
script.render = render

export default script